import { jsx as l } from "react/jsx-runtime";
const o = {
  success: "bg-green-100 text-green-800",
  danger: "bg-red-100 text-red-800",
  warning: "bg-yellow-100 text-yellow-800",
  default: "bg-gray-100 text-gray-800"
};
function a({ children: e, color: s }) {
  const t = "px-2 inline-flex text-xs leading-5 font-semibold rounded-full " + o[s || "default"];
  return /* @__PURE__ */ l("span", { className: t, children: e });
}
export {
  a as Badge
};
